import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import AddWordingsState from './AddNewWordingModal/addWordingContext/addWordingsState/AddWordingsState';
import AddWordingModal from './AddNewWordingModal/AddWordingModal';
import React, { useCallback, useContext } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import { updateCustomerLocalization } from 'backend/customers';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, removeWording, deleteWordingData, dataForSubmit, typeOfModalWindow } =
		useContext<ILocalizationContext>(LocalizationContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleRedirect = useCallback(() => {
		history.push('/clients/customers');
	}, [history]);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateCustomerLocalization(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	const handleDelete = () => {
		if (deleteWordingData) {
			removeWording(deleteWordingData.groupId, deleteWordingData.wordingId);
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleDelete}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteWording"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			{/* <AddWordingsState> // TODO KMD-8157 (delete all logic later)
				<AddWordingModal isVisible={typeOfModalWindow === 'addWording'} onClose={handleCloseModal} />
			</AddWordingsState> */}
		</div>
	);
};

export default ModalWindows;
